<style lang="scss" scoped>

</style>

<template>
  <div>
    <sub-header title="告警记录" />
    <div class="box">
      <el-form
        inline
        size="small"
      >
        <el-form-item label="任务名称">
          <el-input
            v-model="searchModel.taskName"
            placeholder="任务名称"
          />
        </el-form-item>
        <el-form-item label="告警时间">
          <el-date-picker
            v-model="searchModel.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          />
        </el-form-item>
        <el-form-item label="告警状态">
          <el-select
            v-model="searchModel.status"
            clearable
          >
            <el-option
              label="告警中"
              value="firing"
            />
            <el-option
              label="已恢复"
              value="ok"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="handleSearch"
          >
            搜索
          </el-button>
        </el-form-item>
      </el-form>
      <yv-pagination
        ref="alarmPaginationRef"
        :fetcher="fetcher"
      >
        <template #top="{ data }">
          <yv-table
            class="table mb10"
            :data="data"
          >
            <el-table-column label="告警时间">
              <template #default="{ row }">
                {{ formatDate(row.alarmStartTime) }}
              </template>
            </el-table-column>
            <el-table-column label="监控任务">
              <template #default="{ row }">
                <el-link
                  v-if="!['DELETING', 'DELETED', 'RELEASE'].includes(row.taskStatus)"
                  type="primary"
                  :underline="false"
                  @click="$router.push({ name: 'monitor-detail', params: { id: row.taskId } })"
                >
                  {{ row.taskName }}
                </el-link>
                <span v-else>{{ row.taskName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="监控对象"
              prop="monitorAddress"
            />
            <el-table-column
              label="告警内容"
              prop="alarmRuleDesc"
            />
            <el-table-column label="持续时间">
              <template #default="{ row }">
                {{ formatTime(row.alarmRecoveryTime - row.alarmStartTime) }}
              </template>
            </el-table-column>
            <el-table-column
              label="告警状态"
              prop="status"
            >
              <template #default="{ row }">
                {{ formatStatus(row.status) }}
              </template>
            </el-table-column>
          </yv-table>
        </template>
      </yv-pagination>
    </div>
  </div>
</template>

<script>
import YvPagination from '@com/pagination'
import YvTable from '@com/table'
import AlarmService from '@s/alarm'
import SubHeader from '@w/sub-header'
import { dateFormatter } from '../../util'
export default {
  components: {
    SubHeader,
    YvPagination,
    YvTable
  },
  data () {
    return {
      searchModel: {
        taskName: '',
        time: '',
        status: ''
      },
      pickerOptions: {
        disabledDate (val) {
          return val.getTime() >= new Date().getTime() || val <= new Date() - 1000 * 24 * 60 * 60 * 365
        }
      },
      params: {}
    }
  },
  beforeMount () {
    if (this.$route.query.status) {
      this.searchModel.status = this.$route.query.status
      this.params.status = this.searchModel.status
    }
    if (this.$route.query.startTimestamp && this.$route.query.endTimestamp) {
      this.searchModel.time = [dateFormatter(this.$route.query.startTimestamp, '{y}-{m}-{d}'), dateFormatter(this.$route.query.endTimestamp, '{y}-{m}-{d}')]
      this.params.startDate = this.searchModel.time[0]
      this.params.endDate = this.searchModel.time[1]
    }
  },
  methods: {
    fetcher (req) {
      return AlarmService.getAlarmList({
        ...this.params,
        perPage: req.limit,
        curPage: req.page
      })
    },
    formatStatus (status) {
      if (status === 'ok' || status === 'changed' || status === 'disconnected') {
        return '已恢复'
      } else if (status === 'firing') {
        return '告警中'
      } else {
        return '--'
      }
    },
    formatDate (timestamp) {
      return dateFormatter(timestamp)
    },
    formatTime (time) {
      time = Math.floor(time / 1000)
      let str = ''
      const s = time % 60
      const m = Math.floor(time / 60) % 60
      const h = Math.floor(time / 3600) % 24
      const d = Math.floor(time / 86400)
      if (d) {
        str += `${d}天`
      }
      if (h) {
        str += `${h}小时`
      } else if (str) {
        str += '0小时'
      }
      if (m) {
        str += `${m}分`
      } else if (str) {
        str += '0分'
      }
      if (s) {
        str += `${s}秒`
      }
      return str
    },
    handleSearch () {
      this.params = {
        taskName: this.searchModel.taskName,
        startDate: this.searchModel.time[0],
        endDate: this.searchModel.time[1],
        status: this.searchModel.status
      }
      this.$refs.alarmPaginationRef.init()
    }
  }
}
</script>
